import { render, staticRenderFns } from "./DealersForm.vue?vue&type=template&id=6c19c33d&scoped=true&"
import script from "./DealersForm.vue?vue&type=script&lang=js&"
export * from "./DealersForm.vue?vue&type=script&lang=js&"
import style0 from "./DealersForm.vue?vue&type=style&index=0&id=6c19c33d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19c33d",
  null
  
)

export default component.exports